import { IInputs } from './types';

export const formatDataOnSubmit = (data: IInputs) => {
  return {
    ...data,
    category_id: data.category_id.value,
    can_be_created_by: data.can_be_created_by.value,
    storage_period: data.storage_period.value,
    identifier: data.identifier?.value,
    employer_scenario: data.employer_scenario.value,
    employee_scenario: data.employee_scenario?.value,
  };
};

export default formatDataOnSubmit;
